import React from "react";
import FilterBlog from "../../components/FilterBlog/FilterBlog";
import BlogGrid from "../../components/Grid/BlogGrid";
import SortBlog from "../../components/SortBlog/SortBlog";

function Home() {
  return (
    <section className="wrapper">
      <aside>
        <div className="sidebar-items">
          <div className="sidebar-content">
            <h4>Sort</h4>
            <SortBlog />
          </div>
          <div className="sidebar-content">
            <h4>Filter</h4>
            <FilterBlog />
          </div>
        </div>
      </aside>


      <BlogGrid />
    </section>
  );
}

export default Home;
